<template>
  <div>
    <div class="header">
      <div class="container-fluid">

        <b-row class="align-items-center mt-3 mb-2">
          <b-col>
            <span class="text-muted" v-if="tiposFiltrados.length !== tipos.length">
              {{ tiposFiltrados.length }} / {{ tipos.length }} {{ $t('mant_tipos_cambio') }}
            </span>
            <span class="text-muted" v-else>{{ tipos.length }} {{ $t('mant_tipos_cambio') }}</span>
          </b-col>
          <b-col class="text-right">
            <button class="btn btn-sm btn-success mr-2" @click="exportarExcel" :disabled="!tiposFiltrados.length" :title="$t('exportar_excel')">
              <i class="fas fa-file-excel mr-1" aria-hidden="true"></i>
              XLS
            </button>
            <router-link v-if="puedeEditar" :to="{ name: 'tipo-cambio-crear' }">
              <b-button variant="primary" size="sm">
                <i class="ni ni-fat-add mr-1"></i> {{ $t('crear_tipo_cambio') }}
              </b-button>
            </router-link>
          </b-col>
        </b-row>

        <b-row class="align-items-end mb-2">
          <b-col md="3">
            <label class="text-muted" style="font-size:.8rem;">{{ $t('desde') }}</label>
            <b-form-input type="date" size="sm" v-model="desde" />
          </b-col>
          <b-col md="3">
            <label class="text-muted" style="font-size:.8rem;">{{ $t('hasta') }}</label>
            <b-form-input type="date" size="sm" v-model="hasta" />
          </b-col>
          <b-col md="3">
            <b-button size="sm" variant="primary" @click="cargarTipos">
              <i class="fas fa-search mr-1"></i> {{ $t('buscar') }}
            </b-button>
            <b-button size="sm" variant="outline-secondary" @click="limpiarRango">
              {{ $t('limpiar') }}
            </b-button>
          </b-col>
        </b-row>

        <b-alert variant="danger" :show="!!error" dismissible @dismissed="error = ''">
          {{ error }}
        </b-alert>

        <div v-if="cargando" class="text-center text-muted mt-5">
          <b-spinner variant="primary" />
        </div>

        <div v-else-if="tipos.length" class="card shadow" style="margin-bottom: 60px;">
          <div class="tabla-scroll-fixed" ref="tablaTipos">
            <table class="table table-hover align-items-center mb-0">
              <thead class="thead-sticky thead-light">
                <tr>
                  <th class="th-ordenable" @click="ordenarPor('fecha')">
                    <input class="th-search-input" v-model="filterCol.fecha" @click.stop :placeholder="$t('buscar')" />
                    <span class="th-label">{{ $t('fecha') }} <i :class="iconoOrden('fecha')"></i></span>
                  </th>
                  <th v-for="col in columnasParidad" :key="col.key" class="th-ordenable text-right" @click="ordenarPor(col.key)">
                    <span class="th-label">{{ col.label }} <i :class="iconoOrden(col.key)"></i></span>
                  </th>
                  <th style="width:140px;"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in tiposPaginados" :key="item.fecha">
                  <td>{{ soloFecha(item.fecha) }}</td>
                  <td v-for="col in columnasParidad" :key="col.key" class="text-right">
                    {{ formatoNumero(item[col.key]) }}
                  </td>
                  <td class="text-center">
                    <router-link :to="{ name: 'tipo-cambio-detalle', params: { fecha: soloFecha(item.fecha) } }">
                      <b-button size="sm" variant="outline-primary" class="mr-1">
                        <i class="fas fa-pencil-alt"></i>
                      </b-button>
                    </router-link>
                    <b-button v-if="puedeEditar" size="sm" variant="outline-danger" @click="eliminarTipo(soloFecha(item.fecha))">
                      <i class="fas fa-trash"></i>
                    </b-button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="pagination-floating-bar" v-if="tipos.length">
          <div class="d-flex align-items-center">
            <label class="mr-2 mb-0 text-secondary" style="font-size:.85rem;">{{ $t('items_por_pagina') }}</label>
            <select v-model.number="pageSize" @change="currentPage = 1" class="form-control form-control-sm" style="width:70px;">
              <option :value="20">20</option>
              <option :value="50">50</option>
              <option :value="100">100</option>
              <option :value="999999">Todas</option>
            </select>
          </div>
          <div class="d-flex align-items-center" style="gap:12px;">
            <button class="btn btn-outline-secondary btn-sm" :disabled="currentPage === 1" @click="currentPage--">
              <i class="fas fa-arrow-left mr-1"></i> {{ $t('anterior') }}
            </button>
            <span style="font-weight:600;color:#6c757d;font-size:.9rem;">
              {{ $t('pagina') }} {{ currentPage }} {{ $t('de') }} {{ totalPages }}
              <span class="text-muted ml-2" style="font-size:.8rem;">({{ tiposFiltrados.length }} {{ $t('resultados') }})</span>
            </span>
            <button class="btn btn-outline-primary btn-sm" :disabled="currentPage >= totalPages" @click="currentPage++">
              {{ $t('siguiente') }} <i class="fas fa-arrow-right ml-1"></i>
            </button>
          </div>
          <div class="d-flex align-items-center" style="gap:6px;">
            <button class="btn btn-sm btn-scroll-nav" @click="scrollTabla('left')" title="Scroll izquierda"><i class="fas fa-chevron-left"></i></button>
            <button class="btn btn-sm btn-scroll-nav" @click="scrollTabla('right')" title="Scroll derecha"><i class="fas fa-chevron-right"></i></button>
            <button class="btn btn-sm btn-scroll-nav" @click="scrollTabla('top')" title="Ir al inicio"><i class="fas fa-chevron-up"></i></button>
            <button class="btn btn-sm btn-scroll-nav" @click="scrollTabla('bottom')" title="Ir al final"><i class="fas fa-chevron-down"></i></button>
          </div>
        </div>

        <div v-else-if="!cargando" class="text-center text-muted mt-5">
          <i class="fas fa-dollar-sign fa-3x mb-3"></i>
          <p>{{ $t('no_hay_tipos_cambio') }}</p>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import tipoCambioService from '@/api/tipoCambioService';
import utilsService from '@/api/utilsService';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx';

export default {
  name: 'TipoCambioView',
  data() {
    return {
      tipos: [],
      cargando: false,
      error: '',
      desde: '',
      hasta: '',
      ordenColumna: null,
      ordenDireccion: 'asc',
      filterCol: {
        fecha: '',
      },
      currentPage: 1,
      pageSize: 50,
      // Las paridades cruzadas son opcionales en BD, van al final.
      columnasParidad: [
        { key: 'usdClp', label: 'USD/CLP' },
        { key: 'eurClp', label: 'EUR/CLP' },
        { key: 'arsClp', label: 'ARS/CLP' },
        { key: 'copClp', label: 'COP/CLP' },
        { key: 'penClp', label: 'PEN/CLP' },
        { key: 'audClp', label: 'AUD/CLP' },
        { key: 'usdArs', label: 'USD/ARS' },
        { key: 'usdCop', label: 'USD/COP' },
        { key: 'usdPen', label: 'USD/PEN' },
        { key: 'audUsd', label: 'AUD/USD' },
        { key: 'eurUsd', label: 'EUR/USD' },
      ],
    };
  },

  watch: {
    filterCol: { deep: true, handler() { this.currentPage = 1; } },
  },

  mounted() {
    this.$store.dispatch('setSidebarCollapsed', false);
    this._scrollHandler = this._onWindowScroll.bind(this);
    window.addEventListener('scroll', this._scrollHandler, { passive: true });
    this.cargarTipos();
  },

  beforeDestroy() {
    this.$store.dispatch('setSidebarCollapsed', false);
    window.removeEventListener('scroll', this._scrollHandler);
  },

  computed: {
    puedeEditar() {
      return utilsService.puedeEscribir() && utilsService.getRol() !== 'ventas inex';
    },
    tiposFiltrados() {
      const fc = this.filterCol;
      let lista = this.tipos;
      if (fc.fecha) lista = lista.filter(t => this.soloFecha(t.fecha).includes(fc.fecha));
      return lista;
    },
    tiposOrdenados() {
      if (!this.ordenColumna) return this.tiposFiltrados;
      const sorted = [...this.tiposFiltrados];
      sorted.sort((a, b) => {
        let vA = a[this.ordenColumna];
        let vB = b[this.ordenColumna];
        if (vA == null) vA = '';
        if (vB == null) vB = '';
        if (typeof vA === 'number' && typeof vB === 'number') return this.ordenDireccion === 'asc' ? vA - vB : vB - vA;
        vA = String(vA).toLowerCase();
        vB = String(vB).toLowerCase();
        if (vA < vB) return this.ordenDireccion === 'asc' ? -1 : 1;
        if (vA > vB) return this.ordenDireccion === 'asc' ? 1 : -1;
        return 0;
      });
      return sorted;
    },
    totalPages() {
      if (this.pageSize >= 999999) return 1;
      return Math.max(1, Math.ceil(this.tiposOrdenados.length / this.pageSize));
    },
    tiposPaginados() {
      if (this.pageSize >= 999999) return this.tiposOrdenados;
      const start = (this.currentPage - 1) * this.pageSize;
      return this.tiposOrdenados.slice(start, start + this.pageSize);
    },
  },

  methods: {
    soloFecha(valor) {
      if (!valor) return '';
      return String(valor).substring(0, 10);
    },

    // Siempre dos decimales. El valor completo se conserva en la exportacion a
    // Excel, que escribe el numero crudo sin formatear.
    formatoNumero(valor) {
      if (valor === null || typeof valor === 'undefined' || valor === '') return '-';
      const n = Number(valor);
      if (isNaN(n)) return '-';
      return n.toLocaleString('es-CL', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },

    limpiarRango() {
      this.desde = '';
      this.hasta = '';
      this.cargarTipos();
    },

    async cargarTipos() {
      this.cargando = true;
      this.error = '';
      try {
        this.tipos = await tipoCambioService.getAll(this.desde, this.hasta);
        this.currentPage = 1;
      } catch (e) {
        this.error = (e && e.message) ? e.message : 'Ocurrió un error al cargar los tipos de cambio.';
      } finally {
        this.cargando = false;
      }
    },

    eliminarTipo(fecha) {
      Swal.fire({
        title: this.$t('esta_seguro'),
        text: this.$t('eliminar_tipo_cambio_permanente'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('eliminar'),
        cancelButtonText: this.$t('cancelar'),
        confirmButtonColor: '#dc3545',
        cancelButtonColor: '#6c757d',
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            await tipoCambioService.deleteBy(fecha);
            await this.cargarTipos();
            Swal.fire({ text: this.$t('eliminado_correctamente'), icon: 'success', timer: 2000, showConfirmButton: false });
          } catch (e) {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: (e && e.message) ? e.message : this.$t('error_eliminar_tipo_cambio'),
            });
          }
        }
      });
    },

    ordenarPor(columna) {
      if (this.ordenColumna === columna) {
        this.ordenDireccion = this.ordenDireccion === 'asc' ? 'desc' : 'asc';
      } else {
        this.ordenColumna = columna;
        this.ordenDireccion = 'asc';
      }
      this.currentPage = 1;
    },

    iconoOrden(columna) {
      if (this.ordenColumna !== columna) return 'fas fa-sort text-muted';
      return this.ordenDireccion === 'asc' ? 'fas fa-sort-up' : 'fas fa-sort-down';
    },

    scrollTabla(dir) {
      const el = this.$refs.tablaTipos;
      const px = 300;
      if (dir === 'left')   el && el.scrollBy({ left: -px, behavior: 'smooth' });
      if (dir === 'right')  el && el.scrollBy({ left:  px, behavior: 'smooth' });
      if (dir === 'top')    window.scrollTo({ top: 0, behavior: 'smooth' });
      if (dir === 'bottom') window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
    },

    _onWindowScroll() {
      const cont = this.$refs.tablaTipos;
      if (!cont) return;
      const thead = cont.querySelector('thead.thead-sticky');
      if (!thead) return;
      const top = cont.getBoundingClientRect().top;
      thead.style.transform = top < 0 ? `translateY(${-top}px)` : '';
    },

    exportarExcel() {
      const rows = this.tiposOrdenados;
      if (!rows.length) { Swal.fire({ icon: 'info', title: this.$t('no_filas_exportar') }); return; }

      const cols = [{ key: 'fecha', label: this.$t('fecha') }].concat(this.columnasParidad);
      const header = cols.map(c => c.label);
      const data = [header, ...rows.map(r => cols.map(c => {
        if (c.key === 'fecha') return this.soloFecha(r.fecha);
        return r[c.key] == null ? '' : Number(r[c.key]);
      }))];
      const ws = XLSX.utils.aoa_to_sheet(data);
      ws['!cols'] = header.map(h => ({ wch: Math.max(10, String(h).length + 2) }));
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'TiposDeCambio');
      const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
      const blob = new Blob([wbout], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

      const fecha = new Date().toISOString().slice(0, 10);
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `TiposDeCambio_${fecha}.xlsx`;
      document.body.appendChild(a);
      a.click();
      setTimeout(() => { document.body.removeChild(a); URL.revokeObjectURL(url); }, 0);
    },
  },
};
</script>

<style scoped>
.card {
  border-radius: 10px;
  overflow: hidden;
}

.tabla-scroll-fixed {
  overflow-x: auto;
  position: relative;
  font-size: 0.8rem;
}

.thead-sticky {
  position: relative;
  z-index: 2;
  background: #f8f9fa;
}

.th-ordenable {
  cursor: pointer;
  user-select: none;
  min-width: 90px;
  vertical-align: top;
  white-space: nowrap;
}
.th-ordenable:hover {
  background-color: #e9ecef !important;
}

.th-search-input {
  width: 100%;
  font-size: 11px;
  padding: 2px 4px;
  border: 1px solid #ced4da;
  border-radius: 3px;
  margin-bottom: 3px;
  display: block;
  font-weight: normal;
}

.th-label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}

.tabla-scroll-fixed .table th,
.tabla-scroll-fixed .table td {
  font-size: 12px;
}

.btn-scroll-nav {
  width: 32px;
  height: 32px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #ced4da;
  background: #f8f9fa;
  color: #495057;
  border-radius: 6px;
}
.btn-scroll-nav:hover {
  background: #e9ecef;
  border-color: #adb5bd;
}

.pagination-floating-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 500;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 24px;
  background: #fff;
  border-top: 1px solid #dee2e6;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.08);
}
</style>
